var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeechbubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e8262f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M271.41,20.29c-125.06,0-226.45,101.39-226.45,226.45,0,42.66,11.81,82.55,32.32,116.61-5.39,28.57-20.69,72.64-64.24,90.69,0,0,82.4,8.86,135.96-16.83,35.3,22.73,77.29,35.97,122.4,35.97,125.06,0,226.44-101.39,226.44-226.45S396.48,20.29,271.41,20.29Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 191,
    cy: 86.74,
    r: 15.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 273.29,
    cy: 86.74,
    r: 15.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 355.58,
    cy: 86.74,
    r: 15.42
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechbubble);
export default __webpack_public_path__ + "static/media/Speech bubble.1c74b0decc44c07987240bea238018e4.svg";
export { ForwardRef as ReactComponent };